import Numeral from "numeral";
import React from 'react';

class GlobalHelper{
    static addLinks:any = (str:string)=>{
        if(!str) str='';
        str = str.replace(/((http:|https:|www\.)[^\s]+[\w])/g, '<a href="$1" rel="nofollow" target="_blank">$1</a>');
        return {__html:str};
    };

    static getSocialIcon = (social: string) => {
        switch (social) {
            case 'ig_post':
            case 'ig_story':
            case 'instagram':
                return 'fa-instagram-square';
            case 'tk_video':
            case 'tiktok':
                return 'fa-tiktok';
            case 'yt_video':
            case 'youtube':
                return 'fa-youtube-square';
            case 'tw_tweet':
            case 'twitter':
                return 'fa-twitter-square';
        }
    };

    static formatNumber = (num: any) => {
        if (Number(num) >= 1000) {
            num = Numeral(num).format('0.0a');
        }
        return num;
    };

    static openSocialPage = (social: string, username: string) => {
        const socialAccountLinks = {
            instagram: 'https://www.instagram.com/',
            twitter: 'https://twitter.com/',
            tiktok: 'https://www.tiktok.com/@',
            youtube: 'https://www.youtube.com/channel/'
        }
        switch (social) {
            case "instagram":
            case "twitter":
            case "tiktok":
                return (socialAccountLinks[social] + username);
            case "youtube":
                return ('https://www.youtube.com/channel/' + username);
            default:
                return "";
        }
    };

    static renderHumanzAcademyBadge = (badge:boolean)=>{
        if(badge){
            return <div className={"academy-badge"}> <span>Graduate of the <strong>Humanz Influencer Marketing Academy</strong></span> <img height={60} src={"/i/images/academy_badge.png"} alt=""/></div>
        }
    }
}

export default GlobalHelper;